import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './VerifyPage.css';

const VerifyPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkSession } = useAuth();
  const [state, setState] = useState('verifying');
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setState('error');
        setMessage('Aucun jeton de vérification fourni');
        return;
      }

      try {
        const response = await fetch(
          `/.netlify/functions/verify-magic-link?token=${encodeURIComponent(token)}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.ok) {
          setState('success');
          await checkSession();
          setTimeout(() => {
            navigate('/members/dashboard', { replace: true });
          }, 1500);
        } else {
          const error = await response.json();
          setState('error');
          setMessage(error.message || 'Lien invalide ou expiré');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setState('error');
        setMessage('La vérification a échoué. Veuillez réessayer.');
      }
    };

    verifyToken();
  }, [token, navigate, checkSession]);

  return (
    <div className="verify-page">
      <div className="verify-card">
        {state === 'verifying' && (
          <div className="verify-state verifying">
            <div className="spinner"></div>
            <p>Vérification de votre accès...</p>
          </div>
        )}

        {state === 'success' && (
          <div className="verify-state success">
            <div className="success-icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="38" fill="none" stroke="#4caf50" strokeWidth="2" />
                <path d="M25 40L35 50L55 30" stroke="#4caf50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h1>Accès autorisé !</h1>
            <p>Redirection vers votre tableau de bord...</p>
          </div>
        )}

        {state === 'error' && (
          <div className="verify-state error">
            <div className="error-icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="38" fill="none" stroke="#d32f2f" strokeWidth="2" />
                <path d="M28 28L52 52M52 28L28 52" stroke="#d32f2f" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>
            <h1>Échec de la vérification</h1>
            <p>{message}</p>
            <a href="/members" className="retry-link">Demander un nouveau lien</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
